<div class="relative user-menu-container">
    <button 
        (click)="toggleUserMenu()"
        class="flex items-center space-x-2 px-3 py-2 rounded-lg transition-all duration-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 group">
        <div class="user-avatar w-10 h-10 bg-gray-200 rounded-full flex justify-center items-center transition-all duration-300">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-gray-600">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
            </svg>
        </div>
        <span class="font-semibold text-gray-700 text-sm hidden md:block transition-colors duration-300">{{ currentUser?.username || 'User' }}</span>
        <svg class="w-4 h-4 text-gray-500 hidden md:block transition-all duration-300" [class.rotate-180]="isUserMenuOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
    </button>
    
    <!-- Dropdown Menu -->
    <div 
        *ngIf="isUserMenuOpen"
        class="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-50 animate-fadeIn"
        (click)="$event.stopPropagation()">
        <!-- User Info Header -->
        <div class="px-4 py-3 border-b border-gray-200">
            <p class="text-sm font-semibold text-gray-900">{{ currentUser?.username || 'User' }}</p>
            <p class="text-xs text-gray-500 mt-0.5">{{ currentUser?.email || 'user@example.com' }}</p>
        </div>
        
        <!-- Menu Items -->
        <div class="py-1.5">
            <a 
                *ngIf="hasAdminRole()"
                routerLink="/admin"
                (click)="onCollapseNavbar()"
                class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-all duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-3 text-gray-500">
                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
                    <path d="M3 9h18M9 21V9"/>
                </svg>
                <span class="font-medium">Admin</span>
            </a>
            <a 
                routerLink="/change-password"
                (click)="onCollapseNavbar()"
                class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-all duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-3 text-gray-500">
                    <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                <span class="font-medium">Đổi mật khẩu</span>
            </a>
            <button 
                (click)="logout(); onCollapseNavbar()"
                class="w-full flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-all duration-200 text-left">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-3 text-gray-500">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                <span class="font-medium">Đăng xuất</span>
            </button>
        </div>
    </div>
</div>

